import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/settings/contracting-corporation-profile/_layout/shareholders/')({
  component: ShareholdersComingSoon
});
function ShareholdersComingSoon() {
  return <ComingSoonCover disableBlurBackdrop={true} />;
}